import React from 'react';
const painPoints = ['Tu hijo lleva horas con el celular y cuando se lo sacás explota en un berrinche que te agota', 'Intentás poner límites pero terminás cediendo porque no tenés nada que lo entretenga de verdad', 'Sentís que los primeros años se están yendo y tu hijo no está aprendiendo lo que debería', 'Buscás actividades en internet pero nunca encontrás algo completo, ordenado y listo para usar', 'Tu hijo se aburre a los 5 minutos de cualquier actividad y vuelve a pedir la pantalla', 'Ves a otros chicos de su edad que ya saben letras, números o inglés y te preguntás si vas bien'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(254, 242, 242)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-181">
      <div className="mx-auto max-w-3xl" data-id="element-182">
        {/* LABEL */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-183">
          😔 ¿Te sentís identificada?
        </p>

        {/* TÍTULO */}
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-184">
          Esto le pasa al 90% de las mamás
        </h2>

        {/* SUBTÍTULO */}
        <p className="text-center text-sm sm:text-base text-gray-600 mb-6 max-w-xl mx-auto" data-id="element-185">
          Si alguna de estas situaciones te resulta familiar, el{' '}
          <strong className="text-red-500" data-id="element-186">Megapack Anti Pantalla</strong> fue
          creado exactamente para vos.
        </p>

        {/* PAIN POINTS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-187">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-xl p-4 shadow-sm" data-id="element-188">
              <span className="text-red-500 text-base leading-5 shrink-0 font-black" data-id="element-189">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-190">{point}</p>
            </div>)}
        </div>

        {/* PREGUNTA CIERRE */}
        <div className="bg-red-600 rounded-2xl px-6 py-5 text-center mb-6" data-id="element-191">
          <p className="text-white sm:text-xl font-black m-0 mb-1 text-[16px]" data-id="element-192">
            ¿Cuántos años más vas a ver cómo
            <br data-id="element-193" />
            <span className="text-yellow-300" data-id="element-194">la pantalla cría a tu hijo?</span>
          </p>
          <p className="text-red-100 text-xs sm:text-sm font-medium m-0 mt-2" data-id="element-195">
            Los primeros 7 años son los más importantes para el desarrollo del
            cerebro. Ese tiempo no vuelve.
          </p>
        </div>

        {/* CTA DENTRO DEL DOLOR */}
        <div className="text-center mb-6" data-id="element-196"></div>

        {/* DIVISOR */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(249, 115, 22), rgba(255, 255, 255, 0))'
      }} data-id="element-197" />
      </div>
    </section>;
}